function list(params) {
    return new Promise((resolve, reject) => {
        axios
            .get("v1/monthly-targets", {params})
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function start(params) {
    return new Promise((resolve, reject) => {
        axios
            .post("v1/monthly-targets/start", params)
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function store(params) {
    return new Promise((resolve, reject) => {
        axios
            .post("v1/monthly-targets", params)
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function show(id, queryParams = {}) {
    return new Promise((resolve, reject) => {
        axios
            .get('v1/monthly-records/', {params: {monthly_target_id: id, ...queryParams}})
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function update(id, params) {
    return new Promise((resolve, reject) => {
        axios
            .put(`v1/monthly-targets/${id}`, params)
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function destroy(id) {
    return new Promise((resolve, reject) => {
        axios
            .delete(`v1/monthly-targets/${id}`)
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function updateRecord(params) {
    return new Promise((resolve, reject) => {
        axios
            .put('v1/monthly-records/', params)
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function importRecords(formData) {
    return new Promise((resolve, reject) => {
        axios
            .post('v1/monthly-records/import', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function exportRecords(monthly_target_id) {
    return new Promise((resolve, reject) => {
        axios
            .get(`v1/monthly-records/export?monthly_target_id=${monthly_target_id}`, { responseType: 'blob' })
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

const MonthlyTarget = {
    list,
    start,
    store,
    show,
    update,
    destroy,
    updateRecord,
    importRecords,
    exportRecords,
};

let axios = null;

export default ($axios) => {
    axios = $axios;
    return MonthlyTarget;
};
